import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=508bf924&scoped=true"
import script from "./VisitDetail.vue?vue&type=script&lang=ts"
export * from "./VisitDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508bf924",
  null
  
)

export default component.exports